import { useConversationContext } from "~/pages/manifold-nextgen/components/conversations/ConversationContext";
import { ArtifactPreviewBody } from "./ArtifactPreviewBody";
import { useArtifactPreview } from "./useArtifactPreview";

// Resolves a single `[[name]]` reference against the conversation in scope and
// hands the result to the shared renderer. Fetching is all this owns; display
// lives in `ArtifactPreviewBody`, which the project artifacts page reuses against a
// preview it fetched through a pin instead.
export const ArtifactRef = ({ name }: { name: string }) => {
  const scope = useConversationContext();
  const { preview, error, isLoading, notFound, unsupported } = useArtifactPreview(scope, name);

  return (
    <ArtifactPreviewBody
      preview={preview}
      name={preview?.artifact_name ?? name}
      error={error}
      isLoading={isLoading}
      notFound={notFound}
      unsupported={unsupported}
    />
  );
};
